export class MensagemAlerta {
	mensagem?: string;
	link?: string;
	dataInicio?: any;
	dataFim?: any;
}
